<template>
  <v-container grid-list-xs>
    <v-row v-if="subGroup && subGroup.id">
      <v-col cols="12">
        <v-form :submit="submitSearch">
          <v-card color="grey-lighten-2">
            <v-card-title>
              Filtro de pesquisa
              <!-- SIM, É ADMIN POIS ESTA VIEW é para ADMINS -->
              <DialogoIncluirMembroSubGrupo
                                            :user="user"
                                            :subGroup="subGroup"
                                            :floatRight="true"
                                            @updated="updatedCreateEdit" />
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                                v-model="filters.searchText"
                                label="Nome"
                                clearable
                                density="compact"
                                hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-select
                            :items="[50, 100, 200, 500]"
                            v-model="filters.itemsPerPage"
                            label="Resultados por página"
                            density="compact"
                            hide-details></v-select>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-btn color="warning" @click="clearFilters()"><v-icon class="mr-2">mdi-broom</v-icon>Limpar
                  pesquisa</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click="exportSubGroupMembers()">
                  <v-icon>mdi-file-excel-box</v-icon>
                  <span v-if="mdAndUp">Excel</span>
                </v-btn>
                <v-btn color="primary" type="submit">
                  <v-icon class="mr-2">mdi-magnify</v-icon>
                  Pesquisar
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            {{ subGroup?.name }}
            <v-spacer></v-spacer>
            <!-- <v-text-field
              v-model="searchFilter"
              append-inner-icon="mdi-magnify"
              label="Filtrar resultados"
              clearable
              single-line
              hide-details
            ></v-text-field> -->
          </v-card-title>
          <v-data-table
                        :headers="headers"
                        :items="lstObjects"
                        :search="searchFilter"
                        :items-per-page="filters.itemsPerPage"
                        return-object
                        class="elevation-1"
                        hide-default-footer>
            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                              :disabled="requestingApi"
                              v-model="page"
                              :length="maxPage"></v-pagination>
              </div>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span>{{
                $moment(item.created_at).format("DD/MM/YYYY HH:mm")
              }}</span>
            </template>
            <template v-slot:item.role="{ item }">
              <div>
                {{
                  $SUB_GROUP_ROLES_DIC[item.role]
                  ? $SUB_GROUP_ROLES_DIC[item.role].label
                  : item.role
                }}
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <div>
                <v-tooltip location="top" text="Remover membro">
                  <template v-slot:activator="{ props }">
                    <v-btn
                           @click="deleteSubGroupMember(item)"
                           v-bind="props"
                           color="error"
                           icon
                           variant="text"><v-icon>mdi-delete</v-icon></v-btn>
                  </template>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <div v-else-if="requestingApi" class="text-center">
      <v-progress-linear
                         indeterminate
                         color="yellow-darken-2"></v-progress-linear>
      <p class="text-h5">
        Carregando informações do grupo [{{ $route.params.sub_group_id }}]
      </p>
    </div>
    <div v-else class="text-center">
      <p class="text-h5">
        Não foi possível carregar informações do grupo. Tente recarregar a página.
      </p>
    </div>
  </v-container>
</template>
<script>
import DialogoIncluirMembroSubGrupo from "../components/DialogoIncluirMembroSubGrupo.vue";
import { useDisplay } from 'vuetify';
import api from '@/services'
export default {
  setup() {
    // Destructure only the keys we want to use
    const { mdAndUp } = useDisplay();

    return { mdAndUp }
  },
  components: { DialogoIncluirMembroSubGrupo },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      subGroup: null,
      headers: [
        { title: "Nome", align: "start", key: "legal_person.name", sortable: true },
        { title: "Função", align: "start", key: "role", sortable: true },
        { title: "Data de cadastro", key: "created_at", sortable: true },
        { title: "", key: "actions", align: "end", sortable: false },
      ],
      lstObjects: [],
      filters: {
        itemsPerPage: 1,
      },
      editSubGroup: {},
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;

    vm.loadParameters();
  },
  mounted() { },
  activated() {
    var vm = this;
    vm.requestingApi = true;

    api.subGroup
      .get(vm.$route.params.sub_group_id)
      .then((result) => {
        if (vm.subGroup?.id != result?.id) {
          vm.subGroup = result;
          vm.lstObjects = [];
          vm.requestingApi = false;
          vm.submitSearch();
        }
      })
      .catch((err) => {
        if (err.message) {
          vm.$notify({
            type: "warn",
            text: err.message,
          });
        }
      })
      .finally(() => {
        vm.requestingApi = false;
      });
  },
  methods: {
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_subgroup_members_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);
    },
    deleteSubGroupMember(member) {
      var vm = this;
      let _confirm = confirm('Deseja realmente remover este membro?')
      console.log(member);
      if (_confirm) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.subGroupMember
            .delete(member.id)
            .then((result) => {
              let _ixMember = vm.lstObjects.findIndex(x => x.id === member.id)
              vm.lstObjects.splice(_ixMember, 1)
              vm.$notify({
                type: "success",
                text: "Removido com sucesso",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
      vm.searchFilter = null;
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.subGroupMember
            .list(
              {
                ...vm.filters,
                sub_group_id: vm.subGroup?.id,
              },
              page || 1
            )
            .then((result) => {
              vm.lstObjects = result?.data;
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
              vm.$notify({
                type: "success",
                text: "Pesquisa concluída",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    updatedCreateEdit(object) {
      var vm = this;
      if (object) {
        if (!vm.editSubGroup?.id || vm.editSubGroup?.id != object?.id) {
          vm.lstObjects.unshift(object);
        }
        vm.editSubGroup = { ...object };
      }
    },
    exportSubGroupMembers() {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.excel.exportSubGroupMembers({
            ...vm.filters,
            sub_group_id: vm.subGroup?.id,
          }).then((result) => {
            // create file link inx browser's memory
            const href = URL.createObjectURL(result);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;

            link.setAttribute('download', `Membros_${vm.subGroup?.name}_${vm.$moment(new Date()).format("YYYYMMDD-HHmmss")}.xlsx`); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
            resolve(result);
          }).catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
            reject(err);
          })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
  },
  computed: {},
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_subgroup_members_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>